/**
 * Sayıları Türk Lirası formatında biçimlendirir
 */
export const formatCurrency = (value) => {
    return value.toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  
  /**
   * Yüzde değerlerini biçimlendirir
   */
  export const formatPercentage = (value) => {
    return value.toFixed(2) + '%';
  };
  
  /**
   * Virgüllü sayıları parse eder (örn: "19,28" -> 19.28)
   */
  export const parseNumber = (value) => {
    if (typeof value === 'number') return value;
    if (!value) return 0;
    
    const strValue = value.toString()
      .replace(/\s/g, '')         // Boşlukları kaldır
      .replace(/\.(?=.*,)/g, '')  // Binlik ayracı noktaları kaldır (virgülden önce)
      .replace(',', '.');         // Virgülü noktaya çevir
    
    return parseFloat(strValue) || 0;
  };
  
  /**
   * Hisse sembollerini temizler ve standartlaştırır
   */
  export const cleanSymbol = (symbol) => {
    if (!symbol) return '';
    
    return symbol
      .replace(/[^A-Z]/g, '')  // Sadece büyük harfleri tut
      .substring(0, 5);        // Maksimum 5 karakter
  };
  
  /**
   * Türkçe karakterleri İngilizce karakterlere dönüştürür
   */
  export const convertTurkishToEnglish = (text) => {
    const charMap = {
      'Ğ': 'G', 'Ü': 'U', 'Ş': 'S', 'İ': 'I', 'Ö': 'O', 'Ç': 'C',
      'ğ': 'g', 'ü': 'u', 'ş': 's', 'ı': 'i', 'ö': 'o', 'ç': 'c'
    };
    
    return text
      ? text.replace(/[ĞÜŞİÖÇğüşıöç]/g, letter => charMap[letter])
      : '';
  };